export function generateIFrameUrl(url: string): string {
  return `${String(url).trim()}?header=0&bottomDrawer=closed&overview=0&exit=0`;
}
